module.exports = __webpack_public_path__ + "img/img.06ed6a7a.png";